/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useRecodeStore = defineStore("record", {
  actions: {
    async collateralListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          recordUid: payload.recordUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/record/colt/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async updateCollateralFetch(payload) {
      const body = {
        recordUid: payload.recordUid,
        version: payload.version,
        collaterals: payload.collaterals,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/record/colt/update";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async summaryListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          lotUid: payload.lotUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/summary/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async recordListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          lotUid: payload.lotUid,
          catUid: payload.catUid, // priority cat uid
          stockNumber: payload.stockNumber,
          status: payload.status, // ACTIVE,SCAN_OUT,ESTIMATION_COMPLETE
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/record/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async scanOutFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl =
            "/pawn-svc/breaking/scanOut/" +
            payload.breakingUid +
            "/" +
            payload.tkRefNumber;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async scanInFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/scanIn/" + payload.tkRefNumber;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
